/**
 * Popup Banner Overlay - Side Panel
 * Handles open/close with storage to remember dismissal
 */
(function () {
  var STORAGE_KEY = 'popup-banner-overlay-dismissed';

  var panel = document.getElementById('popup-banner-overlay-panel');
  var closeBtn = document.getElementById('popup-banner-overlay-close');
  var tab = document.getElementById('popup-banner-overlay-tab');

  if (!panel || !tab) return;

  var autoOpen = panel.dataset.autoOpen === 'true';
  var delayMs = parseInt(panel.dataset.delay, 10) || 0;
  var waitForPopups = panel.dataset.waitForPopups === 'true';
  var afterDelayMs = parseInt(panel.dataset.afterDelay, 10) || 0;
  var designMode = panel.dataset.designMode === 'true';
  var storageMode = panel.dataset.storageMode || 'session';

  function isDismissed() {
    if (storageMode === 'none') return false;
    var storage = storageMode === 'local' ? localStorage : sessionStorage;
    return storage.getItem(STORAGE_KEY) === '1';
  }

  function setDismissed() {
    if (storageMode === 'none') return;
    var storage = storageMode === 'local' ? localStorage : sessionStorage;
    storage.setItem(STORAGE_KEY, '1');
  }

  function openPanel() {
    panel.classList.add('is-active');
    tab.classList.remove('is-visible');
  }

  function closePanel() {
    panel.classList.remove('is-active');
    tab.classList.add('is-visible');
    setDismissed();
  }

  closeBtn.addEventListener('click', closePanel);
  tab.addEventListener('click', openPanel);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-active')) {
      closePanel();
    }
  });

  function scheduleAutoOpen() {
    if (isDismissed()) {
      tab.classList.add('is-visible');
    } else if (autoOpen) {
      setTimeout(openPanel, delayMs);
    } else {
      tab.classList.add('is-visible');
    }
  }

  function initWithPopupGate() {
    var holds = new Set();
    var deferred = false;
    var pendingTimer = null;

    function clearPendingTimer() {
      if (pendingTimer !== null) {
        clearTimeout(pendingTimer);
        pendingTimer = null;
      }
    }

    function tryOpenAfterPopups() {
      if (isDismissed() || panel.classList.contains('is-active')) return;
      clearPendingTimer();
      pendingTimer = setTimeout(function () {
        pendingTimer = null;
        if (holds.size === 0 && !isDismissed()) {
          openPanel();
        }
      }, afterDelayMs);
    }

    function onGateHold(e) {
      var id = e.detail && e.detail.id;
      if (!id) return;
      holds.add(id);
      clearPendingTimer();
    }

    function onGateRelease(e) {
      var id = e.detail && e.detail.id;
      if (!id) return;
      holds.delete(id);
      if (holds.size === 0 && deferred) {
        tryOpenAfterPopups();
      }
    }

    window.addEventListener('haoma:popup-gate-hold', onGateHold);
    window.addEventListener('haoma:popup-gate-release', onGateRelease);

    if (isDismissed()) {
      tab.classList.add('is-visible');
      return;
    }

    if (!autoOpen) {
      tab.classList.add('is-visible');
      return;
    }

    tab.classList.add('is-visible');

    var normalDelay = Math.max(delayMs, 800);
    setTimeout(function () {
      if (isDismissed() || panel.classList.contains('is-active')) return;
      if (holds.size === 0) {
        openPanel();
      } else {
        deferred = true;
      }
    }, normalDelay);
  }

  // Initial state
  if (waitForPopups && !designMode) {
    initWithPopupGate();
  } else {
    scheduleAutoOpen();
  }
})();
